import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { ReactElement, ReactNode } from "react";

import { ProductTileRenditions } from "@/components/Product/ProductImage/mappedRenditions";
import { ProductTileLayout } from "@/components/Product/ProductTile/productTile.config";
import { ProductTile } from "@/components/Product/ProductTile/productTile.container";
import { stringToBoolean } from "@/utils/attributes";

export type ProductTileAdapterProps = {
    showButton: string | boolean;
    showCategoryLink: string | boolean;
    allowInstantAddToCart: string;
    amountOfFeatures: number;
    useInsidePadding: string | boolean;
    sku: string;
    product: Product<ProductFieldSet.ProductTile>;
    extraButtons?: () => ReactNode;
    cqDataPath?: string;
};

const ProductTileAdapter = ({
    showButton,
    amountOfFeatures,
    showCategoryLink,
    allowInstantAddToCart,
    useInsidePadding,
    sku,
    product,
    extraButtons,
    cqDataPath
}: ProductTileAdapterProps): ReactElement | null => {
    const categoryLink = stringToBoolean(showCategoryLink.toString());
    const button = stringToBoolean(showButton.toString());

    return (
        <ProductTile
            sku={sku}
            product={product}
            allowInstantAddToCart={allowInstantAddToCart}
            extraButtons={extraButtons}
            cqDataPath={cqDataPath}
            productTileConfig={{
                tilePadding: stringToBoolean(`${useInsidePadding}`),
                imageRenditions: ProductTileRenditions,
                amountOfFeatures: amountOfFeatures,
                components: ProductTileLayout.AEM(button, categoryLink)
            }}
        />
    );
};

export { ProductTileAdapter };
